import { auth,baseAuth} from "~/common/utils/json";
import { getIn } from "~/common/plugins/ic-utils";
import { storage } from '~/common/utils/storage';
import { deepAssign } from '~/common/utils';
import axios from '~/common/plugins/axios.js'
export const state = () => ({
  // 主路由
  mainRouter: 'erp',

  // 当前页面路径
  urlPath: 'contact/user',

  // 暂存抽屉页头名称，例如品项型号名
  drawerTitle: '',
  subBreadCrumb: [],// 二级抽屉自定义面包屑导航数组

  // 后台顶部主菜单和左侧菜单
  menuList: [{
    id: 'market',
    name: '市场',
    path: 'market/natural/info',
    icon: 'shop',
    children: [{
      path: 'market/natural',
      id: 'natural',
      name: '自然人',
      icon: 'el-icon-user-solid',
      children: [{
        id: 'info',
        path: 'market/natural/info',
        name: '个人信息'
      }, {
        id: 'experience',
        path: 'market/natural/experience',
        name: '个人经历'
      }, {
        id: 'certificate',
        path: 'market/natural/certificate',
        name: '个人证件'
      }]
    }, {
      id: 'legal',
      path: 'market/legal',
      name: '法人',
      icon: 'el-icon-s-check',
      children: [
        {
          id: 'info',
          path: 'market/legal/info',
          name: '法人信息'
        }, {
          id: 'certificate',
          path: 'market/legal/certificate',
          name: '法人证件'
        }
      ]
    }, {
      id: 'contact',
      path: 'market/contact',
      name: '人脉',
      icon: 'el-icon-user',
      children: [
        {
          id: 'info',
          path: 'market/contact/info',
          name: '授信信息'
        }, {
          id: 'relationship',
          path: 'market/contact/relationship',
          name: '人脉关系'
        }
      ]
    }, {
      id: 'region',
      path: 'market/region',
      name: '区域',
      icon: 'el-icon-help',
      children: [
        {
          id: 'distribution',
          path: 'market/region/distribution',
          name: '区域划分',
        },
        {
          id: 'assignment',
          path: 'market/region/assignment',
          name: '区域分派',
        },
      ]
    }, {
      id: 'invite',
      path: 'market/invite',
      name: '邀请',
      icon: 'el-icon-user'
    }, {
      id: 'content',
      path: 'market/content',
      name: '内容',
      icon: 'el-icon-user'
    }, {
      id: 'activity',
      path: 'market/activity',
      name: '活动',
      icon: 'el-icon-user'
    }]
  },
  /* {
    name: '用户',
    path: 'user/user/management',
    icon: 'users',
    children: [
      {
        path: 'user/user',
        name: '用户',
        icon: 'el-icon-user-solid',
        children: [
          {
            path: 'user/user/management',
            name: '用户管理',
          }, {
            path: 'user/user/register',
            name: '用户注册',
          }
        ]
      },
      {
        path: 'user/website',
        name: '网站',
        icon: 'el-icon-monitor',
        children: [
          {
            path: 'user/website/column',
            name: '专栏管理',
          }, {
            path: 'user/website/article',
            name: '文章审批',
          }
        ]
      }, {
        path: 'user/invite',
        name: '邀请',
        icon: 'el-icon-share',
        children: [
          {
            path: 'user/invite/management',
            name: '邀请管理',
          }, {
            path: 'user/invite/planing',
            name: '市场策划',
          }
        ]
      },
    ]
  },
  {
    name: '商户',
    path: 'shop/shop/management',
    icon: 'shop',
    children: [
      {
        path: 'shop/shop',
        name: '商户',
        icon: 'el-icon-s-shop',
        children: [
          {
            path: 'shop/shop/management',
            name: '商户管理',
          },
          {
            path: 'shop/shop/register',
            name: '商户注册',
          },
        ]
      },
      {
        path: 'shop/member',
        name: '成员',
        icon: 'el-icon-user-solid',
        children: [
          {
            path: 'shop/member/management',
            name: '成员管理',
          },
          {
            path: 'shop/member/match',
            name: '成员对接',
          },
        ]
      },
      {
        path: 'shop/region',
        name: '区域',
        icon: 'el-icon-help',
        children: [
          {
            path: 'shop/region/distribution',
            name: '区域划分',
          },
          {
            path: 'shop/region/assignment',
            name: '区域分派',
          },
        ]
      }
    ]
  }, */
  {
    id: 'account',
    name: '账户',
    path: 'account/account/management',
    icon: 'account',
    children: [{
      id: 'account',
      path: 'account/account',
      name: '账户',
      icon: 'el-icon-s-finance',
      children: [{
          id: 'management',
          path: 'account/account/management',
          name: '账户管理'
        }, {
          id: 'info',
          path: 'account/account/info',
          name: '账户信息'
        },
        // {
        //   id: 'finance',
        //   path: 'account/account/finance',
        //   name: '账户财务'
        // },
        {
          id: 'buyer',
          path: 'account/account/buyer',
          name: '买家信息'
        },
        {
          id: 'seller',
          path: 'account/account/seller',
          name: '供方信息'
        },
        {
          id: 'shop',
          path: 'account/account/shop',
          name: '佣金账户'
        },
        {
          id: 'user',
          path: 'account/account/user',
          name: '积分账户'
        }
      ]
      },
      {
        id: 'bank',
        path: 'account/bank',
        name: '银行',
        icon: 'el-icon-school',
        children: [
        {
          id: 'info',
          path: 'account/bank/info',
          name: '账户银行'
        },
        {
          id: 'accountbankaccount',
          path: 'account/bank/accountbankaccount',
          name: '银行户头'
        },
        {
          id: 'accountbank',
          path: 'account/bank/accountbank',
          name: '银行'
        },
        {
          id: 'account',
          path: 'account/bank/account',
          name: '账号信息'
        }]
      },
      {
        id: 'invoice',
        path: 'account/invoice',
        name: '开票',
        icon: 'el-icon-tickets',
        children: [{
          id: 'info',
          path: 'account/invoice/info',
          name: '开票信息'
        }, {
          id: 'tax',
          path: 'account/invoice/tax',
          name: '税号信息'
        }]
      },
      {
        id: 'contact',
        path: 'account/contact',
        name: '联系人',
        icon: 'el-icon-s-custom',
        children: [{
          id: 'info',
          path: 'account/contact/info',
          name: '联系信息'
        }, {
          id: 'member',
          path: 'account/contact/member',
          name: '成员信息'
        }]
      },
      {
        id: 'agreement',
        path: 'account/agreement',
        name: '协议',
        icon: 'el-icon-document-checked',
        children: [{
          id: 'version',
          path: 'account/agreement/version',
          name: '协议版本'
        }, {
          id: 'signature',
          path: 'account/agreement/signature',
          name: '协议签署'
        }]
      },
      {
        id: 'report',
        path: 'account/report',
        name: '报表',
        icon: 'el-icon-document-copy',
      },
      {
        id: 'credit',
        path: 'account/credit',
        name: '信用',
        icon: 'el-icon-user',
        children: [{
          id: 'verification',
          path: 'account/credit/verification',
          name: '验证信息'
        }, {
          id: 'info',
          path: 'account/credit/info',
          name: '信用信息'
        }]
      }
    ]
  },
  {
    name: '财务',
    id: 'accouting',
    path: 'accouting/bill/payable',
    icon: 'finance',
    children: [{
      id: 'bill',
      path: 'accouting/bill',
      name: '账单',
      icon: 'el-icon-tickets',
      children: [{
        id: 'payable',
        path: 'accouting/bill/payable',
        name: '应收',
      }, {
        id: 'receivable',
        path: 'accouting/bill/receivable',
        name: '应付',
      }, {
        id: 'ledger',
        path: 'accouting/bill/ledger',
        name: '账本',
      }]
    },
      {
        id: 'payment',
        path: 'accouting/payment',
        name: '款单',
        icon: 'el-icon-money',
        children: [{
          id: 'incoming',
          path: 'accouting/payment/incoming',
          name: '收款单',
        }, {
          id: 'outgoing',
          path: 'accouting/payment/outgoing',
          name: '付款单',
        }]
      },
      {
        id: 'tax',
        path: 'accouting/tax',
        name: '税单',
        icon: 'el-icon-document-remove',
        children: [{
          id: 'input',
          path: 'accouting/tax/input',
          name: '进项',
        }, {
          id: 'output',
          path: 'accouting/tax/output',
          name: '销项',
        }]
      }, {
        id: 'accouting',
        path: 'accouting/account',
        name: '科目',
        icon: 'el-icon-files',
        children: [{
          id: 'code',
          path: 'accouting/account/code',
          name: '会计科目',
        }, {
          id: 'analysis',
          path: 'accouting/account/analysis',
          name: '分析科目',
        }]
      }, {
        id: 'report',
        path: 'accouting/report',
        name: '报表',
        icon: 'el-icon-pie-chart'
      }, {
        id: 'order',
        path: 'accouting/order',
        name: '订单',
        icon: 'el-icon-tickets',
        children: [{
          id: 'so',
          path: 'accouting/order/sales/so',
          name: '销售单',
        }, {
          id: 'sales_line',
          path: 'accouting/order/sales/line',
          name: '销售子项',
        },
          {
            id: 'srma',
            path: 'accouting/order/sales/srma',
            name: '销售退货',
          },
          {
            id: 'po',
            path: 'accouting/order/purchasing/po',
            name: '采购单',
          },
          {
            id: 'purchasing_line',
            path: 'accouting/order/purchasing/line',
            name: '采购子项',
          },
          {
            id: 'prma',
            path: 'accouting/order/purchasing/prma',
            name: '采购退货',
          }
        ]
      },
    ]
  },
  {
    name: '物流',
    id: 'shipping',
    path: 'shipping/packing_list',
    icon: 'shipping',
    children: [{
      id: 'packing_list',
      path: 'shipping/packing_list',
      name: '货单',
      icon: 'el-icon-box'
    },
      {
        id: 'waybill',
        path: 'shipping/waybill',
        name: '运单',
        icon: 'el-icon-truck'
      },
      {
        id: 'warehouse',
        path: 'shipping/warehouse',
        name: '仓库',
        icon: 'el-icon-office-building'
      },
      {
        id: 'warehouse_receipt',
        path: 'shipping/warehouse_receipt',
        name: '仓单',
        icon: 'el-icon-office-building'
      }, {
        id: 'qc',
        path: 'shipping/qc',
        name: '品控',
        icon: 'el-icon-s-check'
      }, {
        id: 'sort',
        path: 'shipping/sort',
        name: '分拣',
        icon: 'el-icon-s-check'
      }, {
        id: 'test_sheet',
        path: 'shipping/test_sheet',
        name: '检测单',
        icon: 'el-icon-document-checked'
      }, {
        id: 'report',
        path: 'shipping/report',
        name: '报表',
        icon: 'el-icon-document-copy'
      },
    ]
  },
  {
    name: '营运',
    id: 'operation',
    path: 'operation/job',
    icon: 'run',
    children: [{
      id: 'job',
      path: 'operation/job',
      name: '职位',
      icon: 'el-icon-s-management'
    },
      {
        id: 'policy',
        path: 'operation/policy',
        name: '政策',
        icon: 'el-icon-s-management'
      },
      {
        id: 'budget',
        path: 'operation/budget',
        name: '预算',
        icon: 'el-icon-s-management'
      },
      {
        id: 'department',
        path: 'operation/department',
        name: '部门',
        icon: 'el-icon-s-management'
      },
      {
        id: 'employee',
        path: 'operation/employee',
        name: '员工',
        icon: 'el-icon-s-management'
      },
      {
        id: 'salary',
        path: 'operation/salary',
        name: '薪酬',
        icon: 'el-icon-s-management'
      },
      {
        id: 'attendance',
        path: 'operation/attendance',
        name: '考勤',
        icon: 'el-icon-s-management'
      },
      {
        id: 'kpi',
        path: 'operation/kpi',
        name: '绩效',
        icon: 'el-icon-s-management'
      },
      {
        id: 'report',
        path: 'operation/report',
        name: '报表',
        icon: 'el-icon-s-management'
      },
    ]
  },
  {
    name: '产品',
    id: 'product',
    path: 'product/workbench',
    icon: 'electronics',
    children: [{
      id: 'workbench',
      path: 'product/workbench',
      name: '产品台',
      icon: 'el-icon-s-management',
    }, {
      id: 'brand',
      path: 'product/brand',
      name: '厂牌',
      icon: 'el-icon-s-management',
      children: [{
        id: 'management',
        path: 'product/brand/management',
        name: '厂牌管理'
      }, {
        id: 'info',
        path: 'product/brand/info',
        name: '厂牌信息'
      },
        {
          id: 'authorization',
          path: 'product/brand/authorization',
          name: '供方授权'
        },
        {
          id: 'business_report',
          path: 'product/brand/business_report',
          name: '业务报表'
        }, {
          id: 'info_report',
          path: 'product/brand/info_report',
          name: '信息报表'
        }
      ]
    }, {
      id: 'category',
      path: 'product/category',
      name: '类目',
      icon: 'el-icon-folder-checked',
      children: [{
        id: 'management',
        path: 'product/category/management',
        name: '类目管理'
      },
        {
          id: 'info',
          path: 'product/category/info',
          name: '类目信息'
        }, {
          id: 'info_report',
          path: 'product/category/info_report',
          name: '信息报表'
        },
        {
          id: 'business_report',
          path: 'product/category/business_report',
          name: '业务报表'
        }
      ]
    }, {
      id: 'spu',
      path: 'product/spu',
      name: '品项',
      icon: 'el-icon-goblet',
      children: [{
        id: 'management',
        path: 'product/spu/management',
        name: '品项管理'
      }, {
        id: 'info',
        path: 'product/spu/info',
        name: '品项信息'
      }, {
        id: 'business_report',
        path: 'product/spu/business_report',
        name: '业务报表'
      }, {
        id: 'info_report',
        path: 'product/spu/info_report',
        name: '信息报表'
      }]
    }, {
      id: 'attribute',
      path: 'product/attribute',
      name: '参数',
      icon: 'el-icon-goblet',
      children: [{
        id: 'attribute',
        path: 'product/attribute/attribute',
        name: '参数项'
      },
        // {
        //   id: 'info',
        //   path: 'product/attribute/info',
        //   name: '参数信息'
        // },
        {
          id: 'eccn',
          path: 'product/attribute/eccn',
          name: 'ECCN'
        }, {
          id: 'hscode',
          path: 'product/attribute/hscode',
          name: 'HSCode'
        },{
          id: 'package',
          path: 'product/attribute/package',
          name: '封装'
        }
      ]
    }, {
      id: 'specification',
      path: 'product/specification',
      name: '规格',
      icon: 'el-icon-goblet',
      children: [{
        id: 'info',
        path: 'product/specification/info',
        name: '规格项'
      }, {
        id: 'detail',
        path: 'product/specification/detail',
        name: '规格明细'
      }, {
        id: 'sku',
        path: 'product/specification/sku',
        name: '品项明细SKU'
      },
        // {
        //   path: 'product/specification/code',
        //   name: '库存分类'
        // }
      ]
    }, {
      id: 'report',
      path: 'product/report',
      name: '报表',
      icon: 'el-icon-goblet'
    },
      {
        id: 'price',
        path: 'product/price',
        name: '价格',
        icon: 'el-icon-goblet',
        children: [{
          id: 'price_list',
          path: 'product/price/price_list',
          name: '价格表'
        },
          // {
          //   path: 'product/price/quote',
          //   name: '报价表'
          // },
          {
            id: 'list_price',
            path: 'product/price/list_price',
            name: '目录项'
          },
          {
            id: 'policy',
            path: 'product/price/policy',
            name: '政策'
          },
          {
            id: 'price_rule',
            path: 'product/price/price_rule',
            name: '政策规则'
          },
          // {
          //   path: 'product/price/cost',
          //   name: '成本价'
          // },
          // {
          //   path: 'product/price/listpriceline',
          //   name: '区间价'
          // },
        ]
      },
      {
        id: 'spu_qualified_vendor',
        path: 'product/spu_qualified_vendor',
        name: '合格供方',
        icon: 'el-icon-goblet',

        children: [{
          id: 'management',
          path: 'product/spu_qualified_vendor/management',
          name: '合格供方列表'
        },
        {
          id: 'shopspu',
          path: 'product/spu_qualified_vendor/shopspu',
          name: '合格关系(厂牌)'
        },
        {
          id: 'brandlist',
          path: 'product/spu_qualified_vendor/brandlist',
          name: '合格关系(业务项)'
        }]
      }
    ]
  },
  /* {
    name: '业务',
    path: 'biz/shop/buyer',
    icon: 'biz',
    children: [
      {
        path: 'biz/shop',
        name: '商户',
        icon: 'el-icon-tickets',
        children: [
          {
            path: 'biz/shop/buyer',
            name: '买家',
          },
          {
            path: 'biz/shop/seller',
            name: '供方',
          },
        ],
      },
      {
        path: 'biz/sku',
        name: '库存项',
        icon: 'el-icon-tickets',
        children: [
          {
            path: 'biz/sku/rfq',
            name: '买家',
          },
          {
            path: 'biz/sku/supply',
            name: '供方',
          },
        ]
      },
      {
        path: 'biz/listings',
        name: '商品项',
        icon: 'el-icon-tickets',
        children: [
          {
            path: 'biz/listings/sale',
            name: '买家',
          },
          {
            path: 'biz/listings/sold',
            name: '供方',
          },
        ]
      }
    ]
  }, */
  {
    name: '服务',
    id: 'service',
    path: 'service/currency',
    icon: 'customer',
    children: [{
      id: 'services_item',
      path: 'service/services_item',
      name: '服务项',
      icon: 'el-icon-s-grid',
    },{
      id: 'keyword',
      path: 'service/keyword',
      name: '关键词',
      icon: 'el-icon-discount',
    },{
      id: 'currency',
      path: 'service/currency',
      name: '币种',
      icon: 'el-icon-s-custom',
    },{
      id: 'tax',
      path: 'service/tax',
      name: '税率',
      icon: 'el-icon-s-custom',
    },{
      id: 'tool',
      path: 'service/tool',
      name: '工具',
      icon: 'el-icon-s-grid',
      children: [
        {
          id: 'notifications',
          path: 'service/tool/notifications',
          name: '通知管理',
        },
        {
          id: 'ipfs',
          path: 'service/tool/ipfs',
          name: '附件管理',
        },
        {
          id: 'tag',
          path: 'service/tool/tag',
          name: '标签管理',
        },
        {
          id: 'comments',
          path: 'service/tool/comments',
          name: '评论管理',
        },
        {
          id: 'chat',
          path: 'service/tool/chat',
          name: '聊天管理',
        },
        {
          id: 'mails',
          path: 'service/tool/mails',
          name: '邮箱管理',
        },
      ]
    },{
      id: 'interface',
      path: 'service/interface',
      name: '接口',
      icon: 'el-icon-s-grid',
      children: [
        {
          id: 'openApi',
          path: 'service/interface/openApi',
          name: '接口',
        },
      ]
    },{
      id: 'indexer',
      path: 'service/indexer',
      name: '索引',
      icon: 'el-icon-s-grid',
      children: [
        {
          id: 'dictionary',
          path: 'service/indexer/dictionary',
          name: '字典',
          icon: 'el-icon-s-custom'
        },{
          id: 'language',
          path: 'service/indexer/language',
          name: '语种',
          icon: 'el-icon-s-custom'
        },{
          id: 'time_zone',
          path: 'service/indexer/time_zone',
          name: '时区',
          icon: 'el-icon-s-custom'
        },{
          id: 'region',
          path: 'service/indexer/region',
          name: '区域',
          icon: 'el-icon-s-custom',
        },{
          id: 'industry',
          path: 'service/indexer/industry',
          name: '行业',
          icon: 'el-icon-s-custom',
        },
      ]
    },{
      id: 'policy',
      path: 'service/policy',
      name: '政策',
      icon: 'el-icon-s-grid',
      children: [
        {
          id: 'policy',
          path: 'service/policy/policy',
          name: '政策',
          icon: 'el-icon-s-custom'
        },{
          id: 'rule',
          path: 'service/policy/rule',
          name: '规则',
          icon: 'el-icon-s-custom',
        },{
          id: 'categ_manager',
          path: 'service/policy/categ_manager',
          name: '分类管理',
          icon: 'el-icon-s-custom'
        }
      ]
    },{
      id: 'reporting',
      path: 'service/reporting',
      name: '报表',
      icon: 'el-icon-s-grid',
      children: [
        {
          id: 'metrics',
          path: 'service/reporting/metrics',
          name: '指标',
          icon: 'el-icon-s-data',
        },{
          id: 'dimension',
          path: 'service/reporting/dimension',
          name: '维度',
          icon: 'el-icon-s-data',
        },{
          id: 'dashboard',
          path: 'service/reporting/dashboard',
          name: '仪表盘',
          icon: 'el-icon-monitor',
        }
      ]
    },{
      id: 'engine',
      path: 'service/engine',
      name: '引擎',
      icon: 'el-icon-s-grid',
      children: [
        {
          id: 'search',
          path: 'service/engine/search',
          name: '搜索',
          icon: 'el-icon-s-data',
        },{
          id: 'recommendation',
          path: 'service/reporting/recommendation',
          name: '推送',
          icon: 'el-icon-monitor',
        },{
          id: 'work_flow',
          path: 'service/reporting/work_flow',
          name: '流程',
          icon: 'el-icon-monitor',
        }
      ]
    },
      {
        id: 'remark',
        path: 'service/remark',
        name: '备注',
        icon: 'el-icon-s-custom'
      }, {
        id: 'activity',
        path: 'service/activity',
        name: '活动',
        icon: 'el-icon-document-checked'
      },
      {
        id: 'mapping',
        path: 'service/mapping',
        name: '映射',
        icon: 'el-icon-share',
        children: [{
          id: 'interchange',
          path: 'service/mapping/interchange',
          name: '交互对象',
        },
          {
            id: 'account',
            path: 'service/mapping/account',
            name: '账户映射',
          },
          {
            id: 'monitor',
            path: 'service/mapping/monitor',
            name: '监控日志',
          },
        ]
      },
      {
        id: 'list_mapping',
        path: 'service/list_mapping',
        name: '栏目映射',
        icon: 'el-icon-s-shop',
        children: [
          {
            id: 'column',
            path: 'service/list_mapping/column',
            name: '栏目映射',
          },
          {
            id: 'field',
            path: 'service/list_mapping/field',
            name: '标准字段',
          },
        ]
      },
    ]
  },
  {
    name: '平台',
    id: 'portal',
    path: 'portal/website',
    icon: 'product',
    children: [
      /*{
            id: 'user',
            path: 'portal/user',
            name: '用户',
            icon: 'el-icon-user-solid',
            children: [{
                id: 'management',
                path: 'portal/user/management',
                name: '用户管理',
            }, {
                id: 'register',
                path: 'portal/user/register',
                name: '用户注册',
            }]
        }, {
            id: 'shop',
            path: 'portal/shop',
            name: '商户',
            icon: 'el-icon-s-shop',
            children: [{
                    id: 'management',
                    path: 'portal/shop/management',
                    name: '商户管理',
                },
                {
                    id: 'register',
                    path: 'portal/shop/register',
                    name: '商户注册',
                },
                {
                    id: 'member',
                    path: 'portal/shop/member',
                    name: '成员对接',
                },
            ]
        }, */
    {
      id: 'website',
      path: 'portal/website',
      name: '网站',
      icon: 'el-icon-monitor',
    },
    {
      id: 'tenant',
      path: 'portal/tenant',
      name: '租户',
      icon: 'el-icon-share',
    },
    {
      id: 'whitepaper',
      path: 'portal/whitepaper',
      name: '白皮书',
      icon: 'el-icon-share',
    },
    {
      id: 'contract',
      path: 'portal/contract',
      name: '合约',
      icon: 'el-icon-share',
    },
    {
      id: 'internal_partner',
      path: 'portal/internal_partner',
      name: '伙伴',
      icon: 'el-icon-share',
    },
    {
      id: 'external_partner',
      path: 'portal/external_partner',
      name: '合伙人',
      icon: 'el-icon-share',
      },
      {
        id: 'grant',
        path: 'portal/grant',
        name: '授权',
        icon: 'el-icon-share',
        children: [{
          id: 'position',
          path: 'portal/grant/position',
          name: '岗位表',
        },
          {
            id: 'privilege',
            path: 'portal/grant/privilege',
            name: '权限表',
            icon: 'el-icon-s-management'
          },
        ]
      },
      {
        id: 'quota',
        path: 'portal/quota',
        name: '配额',
        icon: 'el-icon-share',
      },
      {
        id: 'data',
        path: 'portal/data',
        name: '数据',
        icon: 'el-icon-share',
      },
      {
        id: 'settlement',
        path: 'portal/settlement',
        name: '结算',
        icon: 'el-icon-share',
      },

    ]
  }],
  showEditBtn: true,
  showEditAuthBtn: true
});

export const mutations = {
  set_urlPath(state, v) {
    state.urlPath = v;
    // 页面切换是清空抽屉页头
    state.drawerTitle = '';
    state.subBreadCrumb =[];
  },
  set_drawerTitle(state, v) {
    // 列表行点击时手动更改页头名称
    state.drawerTitle = v;
  },
  set_subBreadCrumb(state, v) {//二级抽屉
    state.subBreadCrumb = v;
  },
  showEdit(state, playload) {
    const urlArr = playload.path.split("/").filter((item) => item);
    const key=playload.keyword??='update'

    if (getIn(urlArr, auth) && ( getIn(urlArr, auth)[key] )) {
        playload.option.edit = true
        
    }else if(playload.noPerm===true){
        playload.option.edit = playload.active
    }else{
        playload.option.edit = false
    }
    console.log(playload.option.edit)
    state.showEditBtn =  playload.option.edit
  },
  //是否显示变更按钮
  showChange(commit, playload) {
    const urlArr = playload.path.split("/").filter((item) => item);
    if (getIn(urlArr, auth) && ( getIn(urlArr, auth)["change"])) {
        playload.option.edit = true
    }else if(playload.noPerm===true){
        playload.option.edit = playload.active
    }else{
        playload.option.edit = false
    }
  },
  showEditAuth(state, playload) {
    const urlArr = playload.path.split("/").filter((item) => item);
    let f = true
    const key=playload.keyword??='update'
    
    if (getIn(urlArr, auth) && (getIn(urlArr, auth)[key])) {
      f = true
    } else {
      f = false
    }
    console.log(f,key )
    state.showEditAuthBtn = f
    return f
  }
};

export const actions = {
  updateTab(commit, { nav, tabOption, option }) {
    tabOption.tabNav = nav;
    if (nav.length == 0) {
      option.showAll = true;
    }
    if (!nav.map(({ id }) => id).includes(tabOption.nowTab)) {
      tabOption.nowTab = nav[0].id;
    }
  },
  showDetail(commit, path) {
    //首次登陆没取到接口的auth,不能用json的auth
    let auth= storage.get('profile') ? deepAssign(baseAuth, storage.get('profile').auth) : { ...baseAuth };
    let p = path
    if(/\?/.test(path)) {
      p = path.split('?')[0]
    }
    const urlArr = p.split("/").filter((item) => item);
    return getIn(urlArr, auth) ? getIn(urlArr, auth)["read"] : false;
  },
  //判断是否有某一权限
  hasPerm(commit, playload) {
    //首次登陆没取到接口的auth,不能用json的auth
    let auth= storage.get('profile') ? deepAssign(baseAuth, storage.get('profile').auth) : { ...baseAuth };
    let p = playload.path
    if(/\?/.test(playload.path)) {
      p = playload.path.split('?')[0]
    }
    const urlArr = p.split("/").filter((item) => item);
    return getIn(urlArr, auth) ? getIn(urlArr, auth)[playload.keyword] : false;
  },

};

export const getters = {
  urlPath:(state=>state.urlPath),
  menuList:(state=>state.menuList),
  mainRouter:(state=>state.mainRouter),
  // 顶部主菜单
  mainMenus(state) {
    const {urlPath, menuList, mainRouter} = state;

    // 顶部当前菜单
    const mainMenuType = urlPath.split('/')[0];

    return menuList.map(({path, ...spare}) => ({
      ...spare,
      path,
      // 主菜单高亮
      active: path.indexOf(mainMenuType) === 0,
      fullPath: `/${mainRouter}/${path}`
    })).filter(item => auth[mainRouter] ? item.id in auth[mainRouter] : false);
  },
  // 左侧菜单
  sideMenus(state) {

    const {urlPath, menuList, mainRouter} = state;

    // 当前路由
    const curUrlPath = urlPath.split('/');

    // 顶部主菜单
    const mainMenuType = curUrlPath[0];
    // 左侧一级菜单
    const sideMainType = curUrlPath[1];
    const curSideMenu = menuList.find(({path}) => path.indexOf(mainMenuType) === 0);
    if (!curSideMenu) return [];

    let filterSideMenu = curSideMenu.children.filter(item => auth[mainRouter][mainMenuType] ? item.id in auth[mainRouter][mainMenuType] : false);
    return filterSideMenu.map(({path, children, ...spare}) => ({
      ...spare,
      // 左侧二级菜单
      ...(
        children ? {
          children: children.map(({path, ...spare}) => {
            return ({
              ...spare,
              path,
              active: path === urlPath,
              fullPath: `/${mainRouter}/${path}`
            })
          }).filter(item => {
              let ele = auth[mainRouter][mainMenuType][spare.id]
              for (const key in ele) {
                if (ele[key].list) {
                  return ele ? item.id in ele : false
                }
              }
            }
          )
        } : {}
      ),
      path,
      // 左侧菜单高亮
      active: path === `${mainMenuType}/${sideMainType}`,
      fullPath: `/${mainRouter}/${path}`
    }));
  }
};
export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
}
